<template>
  <main
    class="d-flex flex-column gr-4"
    data-qa="document_content"
  >
    <DocumentMobileBanner
      v-if="isMobile"
      :static-path="staticPath"
      :is-russia="isRussia"
    />

    <section
      v-if="isMobile && companyCardHref"
      class="pa-4 elevation-1 rounded-sm"
      data-qa="document_company_card_download"
      :class="{ 'px-4': isMobile }"
    >
      <DocumentDownloadLink
        :href="companyCardHref"
        :label="t('Скачать карточку компании', options)"
      />
    </section>

    <AddressSection
      :title="addressTitle"
      :items="addressItems"
      :company-card-href="isMobile ? undefined : companyCardHref"
      :head-office-href="headOfficeHref"
      :physical-address="physicalAddress"
      :is-mobile="isMobile"
      :class="{ 'px-4': isMobile }"
    />

    <MediaSection
      v-if="showMediaSection"
      :site-domain="siteDomain"
      :physical-address="physicalAddress"
      :class="{ 'px-4': isMobile }"
    />

    <DocumentsSection
      :title="t('Документы юридического лица', options)"
      :items="documents"
      :updated-date="documentsUpdatedDate"
      :is-mobile="isMobile"
      :class="{ 'px-4': isMobile }"
    />
  </main>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import formatDtUpdate from 'src/utils/formatDtUpdate'
import AddressSection from 'src/components/pages/info/document/index/components/AddressSection.vue'
import MediaSection from 'src/components/pages/info/document/index/components/MediaSection.vue'
import DocumentsSection from 'src/components/pages/info/document/index/components/DocumentsSection.vue'
import DocumentMobileBanner from 'src/components/pages/info/document/index/components/DocumentMobileBanner.vue'
import DocumentDownloadLink from 'src/components/pages/info/document/index/components/DocumentDownloadLink.vue'
import getCompanyCardHref from 'src/components/pages/info/document/index/_functions/get-company-card-href'
import getDocumentsByCountry from 'src/components/pages/info/document/index/_functions/get-documents-by-country'
import {
  getAddressItems,
  getAddressTitle,
} from 'src/components/pages/info/document/index/_functions/get-address-content'
import type { DocumentPageContext } from 'src/components/pages/info/document/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  context: DocumentPageContext
}>()

const isMobile = computed(() => props.context.flavour === 'mobile')
const countryIso = computed(() => props.context.request.country.iso)
const isRussia = computed(() => props.context.request.country.is_russia)
const staticPath = computed(() => props.context.global.static.src)
const siteDomain = computed(() => props.context.request.site.domain)
const physicalAddress = computed(() => props.context.company?.physical_address)
const translate = (text: string) => t(text, options)

const companyCardHref = computed(() => (
  getCompanyCardHref(staticPath.value, countryIso.value)
))

const addressTitle = computed(() => getAddressTitle(countryIso.value, translate))
const addressItems = computed(() => getAddressItems(staticPath.value, countryIso.value, translate))
const documents = computed(() => (
  getDocumentsByCountry(staticPath.value, countryIso.value, translate)
))
const documentsUpdatedDate = computed(() => formatDtUpdate(props.context.dt_update))

const showMediaSection = computed(() => (
  isRussia.value && !siteDomain.value.includes('ydoc')
))

const headOfficeHref = computed(() => (
  ['BY', 'KZ', 'KG'].includes(countryIso.value) ? 'https://medrocket.me/documents/' : undefined
))
</script>
